import React, {useState,useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import {
  Button,
  FormControl,
  InputLabel,
  InputAdornment,
  makeStyles,
  TextField,
  Typography,
  MenuItem,
  IconButton,
  Grid,
  Avatar,
  Select,
  OutlinedInput,
  TextareaAutosize
} from '@material-ui/core';

import formStyles from '../../../assets/jss/components/formStyles';
import { DropzoneDialog } from 'material-ui-dropzone';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { FormikProps } from 'formik';
import { RootState } from '../../../app/rootReducer';
import { EnhancedAddOrEditRecipeStepFormValues } from './EnhancedAddOrEditRecipeStepForm';
import { useHistory, useLocation } from 'react-router';
import { ADD_RECIPE, ADD_RECIPE_INGREDIENT_VIEW, MY_RECIPES, editNutrintion } from '../../../constants/routes';
//import { getDiagnosesForProgram } from '../../../slices/diagnosisSlice';
import { DisplayFormikState } from '../../../components/DisplayFormikState';
import { addLibraryImageToS3, addRecipeToS3 } from '../../../api/recipeRequests';
import { useParams, } from 'react-router';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import  SIMG  from '../../../assets/images/sampleimg.png'; 

import Resizer from "react-image-file-resizer";

import IngidiansList from './StepsList';
import { setSuccessMsg } from '../../../slices/alertSlice';
import { updateStepPositionFromWeb } from '../../../slices/recipeStepsSlice';



interface IAddOrEditRecipeStepFormProps {}

const useStyles = makeStyles(formStyles);

interface Option {
  label: string;
  value: string;
}

export const AddOrEditRecipeStepForm: React.FC<
  IAddOrEditRecipeStepFormProps & FormikProps<EnhancedAddOrEditRecipeStepFormValues>
> = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  
  // useEffect(()=>{
  //   setrecipeIngredient();
  // },[])
  const isAddStudent = location.pathname === ADD_RECIPE_INGREDIENT_VIEW;
  const debug = false;
  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleBlur,
    handleChange,
    setFieldValue,
    getFieldMeta,
    handleReset
  } = props;

  const { recipeIngridientLoading, recipeSteps, recipeData  } = useSelector(
    (state: RootState) => {
      return {
        recipeIngridientLoading: state.recipeIngredient.loading,
        recipeSteps: state.recipeStep.recipeSteps,
        recipeData: state.recipe.recipe,
      };
    },
    shallowEqual
  );
  
  const customStyles = {
    control: (base: any, state: any) => ({
      ...base,
      background: '#FAFAFA',
      // match with the menu
      borderRadius: '8px',
      padding: '1.5px 1.5px',

      borderColor: state.isFocused ? '#0092BC' : '#C0C0C0',

      // Overwrittes the different states of border
      '&:hover': {
        // Overwrittes the different states of border
        borderColor: state.isFocused ? '#0092BC' : '#C0C0C0',
      },
      // Removes weird border around container
      boxShadow: state.isFocused ? null : null,
    }),
    menu: (base: any) => ({
      ...base,
      background: '#FAFAFA',
      // override border radius to match the box
      borderRadius: 0,
      // kill the gap
      marginTop: 0,
    }),
    menuList: (base: any) => ({
      ...base,
      background: '#FAFAFA',
      // kill the white space on first and last option
    }),
  };
  let renderedAltName: string | undefined = '';
  let renderedAvatar: string | undefined = '/static/images/avatar/1.jpg';
  renderedAltName = values.stepTitle;
  renderedAvatar =
    values.stepUrl !== 'no-url' ? values.stepUrl : renderedAvatar;
  const [openModal, setOpenModal] = useState(false);
  //let rrid=useParams<{ recipeId: string }>();
  const { recipeId } = useParams<{ recipeId: string | undefined }>();
  let rcheck: string | number | readonly string[] | undefined;
  if(recipeId)
  {
    rcheck=recipeId;
    let formData = new FormData();  
    formData.append('recipeId', rcheck); 
  }
  function sethandlerecipeid(){
    setFieldValue('recipeId', rcheck);
  }

  let renderUnit=[];
  renderUnit=[
    { "label": "Kg",
    "value": "Kg"
  },
  { "label": "g",
  "value": "g"
  },
  { "label": "lb",
    "value": "lb"
  },
  { "label": "oz",
    "value": "oz"
  }];

  function getImageUrl(imguri:any)
  {
    let arr=imguri.split(",");
    let mime=arr[0].match(/:(.*?);/)[1];
    let data=arr[1];

    let dataStr=atob(data);
    let n=dataStr.length;
    let dataArr=new Uint8Array(n);
    while(n--)
    {
      dataArr[n]=dataStr.charCodeAt(n);
    }
    let file = new File([dataArr],'file.jpg',{type:mime});
    //console.log(file);
    return file;
  }
  async function getSaveIndraft(id:string) {
    let crecipe=window.confirm("Do you want save this recipe in draft.")
    if(crecipe)
    {
      history.push(MY_RECIPES);
      dispatch(setSuccessMsg(`Recipe saved in drafts successfully..!`));

    }
  }
  return (
     

    <div>
     
      <div style={{ margin: '0px 0px 32px' }}>
        
        <Typography variant='h4' className={classes.welcomeBackText}>
          {/* {isAddStudent ? 'Add Student to program' : 'Edit Counselor profile'} */}
          {isAddStudent ? 'Add Step' : 'Add Step'}
        </Typography>
        <Typography variant='body1' className={classes.loginText}>
          {/* {isAddStudent ? 'Enter student details' : ''} */}
          {isAddStudent ? 'Enter recipe details' : ''}
        </Typography>
      </div>
      <form onSubmit={handleSubmit}>
        
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'
        >
          <br/>
            <Grid item md={12} xs={12}>
                <Button
                    color='primary'
                    startIcon={
                      <ArrowBackIosIcon
                        fontSize='small'
                        style={{ paddingRight: '0px' }}
                      />
                    }
                    onClick={(e) => {
                      history.push(editNutrintion(recipeId));
                    }}
                    size='small'
                  >
                    Back
                  </Button>
            </Grid>
            <Grid item md={1} xs={12}  >
            </Grid>
            <Grid item md={12} xs={12}  >
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                flexDirection: 'row',
              }}
            >
              <IconButton onClick={() => setOpenModal(true)}>
                {/* <Avatar
                  src={renderedAvatar}
                  alt={renderedAltName}
                  style={{ width: 100, height: 100 }}
                /> */}
                {values.stepUrl && values.stepUrl !== 'no-url'? 
                  <img src={values.stepUrl} style={{ width: 56, height: 56 }}/>:
                  <img src={SIMG} style={{ width: 56, height: 56 }}/>
                }
              </IconButton>
              <Typography
                variant='subtitle1'
                style={{ marginLeft: '0.6rem' }}
                className={classes.label}
              >
                Add Step Picture
                <p style={{fontSize:'12px',color:'gray'}}>Image file should be .jpg and .png only and Size should be less than 5MB.</p>
              </Typography>
            </div>
          </Grid>
          <Grid item md={12} xs={12}>
            <FormControl
              required
              className={classes.formControl}
              style={{ width: '100%', paddingRight: '0.4em' }}
            >
              <Typography variant='subtitle1' className={classes.label}>
                 Step Title  <span style={{color:'red'}}>*</span>
              </Typography> 
              {/* <input
                placeholder='Recipe sId'
                type='hidden'
                name='recipeId'
                value={setFieldValue('recipeId', rcheck)}
               
              /> */}
              <TextField
                placeholder='Enter Title'
                type='text'
                name='stepTitle'
                variant='outlined'
                size='small'
                value={values.stepTitle}
                onChange={handleChange}
                onKeyUp={sethandlerecipeid}
                onBlur={handleBlur}
                error={(errors.stepTitle && touched.stepTitle) as boolean}
                helperText={errors.stepTitle && touched.stepTitle && errors.stepTitle}
                InputLabelProps={{
                  classes: {
                    root: classes.heading,
                    focused: classes.cssFocused,
                  },
                }}
              />
            </FormControl>
          </Grid>
          <Grid item md={12} xs={12}>
            <FormControl required className={classes.formControl}>
              <Typography variant='subtitle1' className={classes.label}>
                 Description <span style={{color:'red'}}>*</span>
              </Typography>
              {/* <TextareaAutosize
                id='stepDescription'
                placeholder='Step Description'
                name='stepDescription'
                value={values.stepDescription}
                onChange={handleChange}
                onBlur={handleBlur}
                style={{ height:'100px' }}
                error={(errors.stepDescription && touched.stepDescription) as boolean}
                helperText={errors.stepDescription && touched.stepDescription && errors.stepDescription}
                InputLabelProps={{
                  classes: {
                    root: classes.heading,
                    focused: classes.cssFocused,
                  },
                }}
              /> */}
               <TextField
                placeholder='Step Description'
                id='stepDescription'
                type='text'
                name='stepDescription'
                variant='outlined'
                size='small'
                value={values.stepDescription}
                onChange={handleChange}
                onKeyUp={sethandlerecipeid}
                onBlur={handleBlur}
                error={(errors.stepDescription && touched.stepDescription) as boolean}
                helperText={errors.stepDescription && touched.stepDescription && errors.stepDescription}
                InputLabelProps={{
                  classes: {
                    root: classes.heading,
                    focused: classes.cssFocused,
                  },
                }}
              />
            </FormControl>
          </Grid>
          
          <Grid item md={3} xs={12}>
                <Button
                className={classes.secondaryButton}
                variant='contained'
                color='primary'
                type='submit'
                // fullWidth
                
               
              >
                Add Step
              </Button>
              
          </Grid>
          <Grid item md={3} xs={12}>
              {recipeData && recipeData.isCompleted===false?
                <Button
                className={classes.secondaryButton}
                variant='contained'
                color='primary'
                type='button'
                disabled={recipeIngridientLoading}
                // fullWidth
                onClick={() => {
                  getSaveIndraft(recipeData.id);
                }}
              >
                Save in draft 
              </Button>:""
              }
          </Grid>
          <Grid item md={3} xs={12}>
            <Button
              className={classes.secondaryButton}
              variant='contained'
              color='primary'
              type='reset'
              onClick={handleReset}
              // disabled={recipeIngridientLoading}
              // fullWidth
            >
               Clear
            </Button>
          </Grid>
          
          {recipeSteps && recipeSteps.length > 0?
            <Grid item md={3} xs={12}>
              <Button
                className={classes.secondaryButton}
                variant='contained'
                color='primary'
                type='button'
                onClick={ async() => {
                let chkstep= await dispatch(updateStepPositionFromWeb(recipeSteps,history));    
                history.push(ADD_RECIPE);
              
                }}
              >
                {isAddStudent ? 'Complete' : 'Complete'} Recipe
              </Button>
            </Grid>:""
          }

        </Grid>
        <DropzoneDialog
          acceptedFiles={['image/jpeg,image/png,image/jpg']}
          cancelButtonText={'Cancel'}
          submitButtonText={'Submit'}
          maxFileSize={5242880}
          filesLimit={1}
          open={openModal}
          onClose={() => setOpenModal(false)}
          onSave={async (files:any) => {
            try {
              if (files.length > 0) {
                let file = files[0];
                Resizer.imageFileResizer(
                  file,
                  680,
                  420,
                  "JPEG",
                  100,
                  0,
                  async(uri:any) => {
                    //console.log(uri);
                    console.warn("Form data view--->" + JSON.stringify(uri));
                   let fdata= getImageUrl(uri);
                   //setImg(fdata);
                   const formData = new FormData();
                   formData.append('file', fdata);
                   //dispatch(addRecipeToS3(formData));
                   let urldatanxt = await addRecipeToS3(formData);
                   // setImage(url);
                   // url.push(urldata);
                   //console.log("res data---->"+urldatanxt)
                   //let jurl=JSON.stringify(urldatanxt)
                   setFieldValue('stepUrl', urldatanxt);
                  },
                  "base64",
                  200,
                  200
                );
                // const formData = new FormData();
                // console.warn("Form data view--->"+JSON.stringify(formData));
                // formData.append('file', file);
                //  //dispatch(addRecipeToS3(formData));
                // //const url = await addRecipeToS3(formData);
                // const url = await addLibraryImageToS3(formData,files);

                // // setImage(url);
                // setFieldValue('stepUrl', url);
              }
              setOpenModal(false);
            } catch (err) {
              console.log(err);
            }
          }}
          showPreviews={true}
          showFileNamesInPreview={true}
        />
        {debug ? <DisplayFormikState {...props} /> : ''}
      </form>
     
    </div>
  );
};
